exports.survey = function(radioGroupName) {
    const duplicateSection = document.getElementById('why-more-than-once-section');
    if (!duplicateSection) return;

    const howManySubmitsRadios = Array.from(
        document.querySelectorAll(`input[type="radio"][name="${radioGroupName}"]`)
    );
    if (!howManySubmitsRadios.length) return;

    function shouldShowWhySubmittedMoreThanOnceSection() {
        const selectedOption = howManySubmitsRadios.find((r) => r.checked);
        return selectedOption && (selectedOption.value === '2' || selectedOption.value === '3-or-more');
    }

    function update() {
        duplicateSection.style.display = shouldShowWhySubmittedMoreThanOnceSection() ? '' : 'none';
    }

    howManySubmitsRadios.forEach(function(radio) {
        radio.addEventListener('change', update);
    });

    update();
};
